import { useContext } from 'react';
import { AuthorBatchContext, type AuthorBatchContextType } from '@/contexts/AuthorContext';

/** Access the batched author-metadata loader. Must be used within AuthorProvider. */
export function useAuthorBatch(): AuthorBatchContextType {
  const context = useContext(AuthorBatchContext);
  if (context === undefined) {
    throw new Error('useAuthorBatch must be used within an AuthorProvider');
  }
  return context;
}
